import React from 'react';

const ClientPaymentDashboard = React.lazy(
  () => import('../features/account/Account'),
);

export const paymentRoutes = [
  {
    path: 'client',
    name: 'Client',
    component: ClientPaymentDashboard,
    exact: true,
  },
];
